import { createApi } from '@reduxjs/toolkit/query/react';

import OfficeService from '../services/OfficeService';

export const OFFICE_BASIC_LIST_TAG = 'officeBasicList';

const api = createApi({
  reducerPath: 'officeApi',
  tagTypes: [OFFICE_BASIC_LIST_TAG],
  endpoints: (build) => ({
    basicList: build.query({
      queryFn: async () => {
        return {
          data: await OfficeService.getOfficesBasicList(),
        };
      },
      providesTags: [OFFICE_BASIC_LIST_TAG],
    }),
  }),
});

export default api;
export const { useBasicListQuery } = api;
